import { render, staticRenderFns } from "./FleetCard.vue?vue&type=template&id=852853c6&"
import script from "./FleetCard.vue?vue&type=script&lang=js&"
export * from "./FleetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports